import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Tab, Tabs } from 'react-bootstrap'
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import defaultPalettes from '../Palettes';
import GlobalContext from '../GlobalContext';
import ImageInput from '../components/ImageInput';
import { useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import "../css/sidebar.css"
import "../css/inputs.css"
import { RiDeleteBin6Line, RiFontSize, RiCheckLine, RiCloseLine, RiContactsBookLine, RiCalendar2Line, RiMenuAddLine, RiEraserLine, RiGoogleLine } from 'react-icons/ri'
import { AiFillEyeInvisible } from 'react-icons/ai'
import GoodCheck from '../components/GoodCheck';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';
import socketIO from "socket.io-client";
import GoodNumber from '../components/GoodNumber';
import GroupSettings from './GroupSettings';
import ThemeSettings from './ThemeSettings';
import OpeningSettings from './OpeningSettings';
import GoodSwitch from '../components/GoodSwitch';


const defCategories = [
    {
        ID: 0,
        cat_name: "nocategory",
        cat_apt: 0,
        cat_color: "#ff00ff",
        loaded: true
    }
]

const defEditShopValues = {
    ID: undefined,
    sho_name: '',
    sho_message: '',
    sho_message_time: undefined,
    sho_sms_sender: '',
    sho_enable_cr: 0,
    sho_default_prefix: 41,
    sho_default_enable_sms: false,
    sho_default_enable_email: false,
    Mailer_ID: undefined
}
const defEditShopChecks = {
    touched: {
        ID: false,
        sho_name: false,
        sho_message: false,
        sho_message_time: false,
        sho_sms_sender: false,
        sho_lang: false,
        sho_enable_cr: false,
        sho_default_prefix: false,
        sho_default_enable_sms: false,
        sho_default_enable_email: false,
    },
    check: {
        ID: (v) => { return true },
        sho_name: (v) => { return v.length > 0 && v.length < 51 },
        sho_message: (v) => { return v.length > 0 && v.length < 150 },
        sho_message_time: (v) => { return v > 0 },
        sho_sms_sender: (v) => { return v.length > 0 && v.length <= 11 },
        sho_default_enable_sms: (v) => { return true },
        sho_default_enable_email: (v) => { return true },
        Mailer_ID: (v) => { return true }
    },
    good: {
        ID: false,
        sho_name: false,
        sho_message: false,
        sho_message_time: false,
        sho_sms_sender: false,
        sho_enable_cr: false,
        sho_default_prefix: false,
        sho_default_enable_sms: false,
        sho_default_enable_email: false,
    },
    bad: {
        ID: false,
        sho_name: false,
        sho_message: false,
        sho_message_time: false,
        sho_sms_sender: false,
        sho_enable_cr: false,
        sho_default_prefix: false,
        sho_default_enable_sms: false,
        sho_default_enable_email: false,
    },
}


const ShopSettings = ({ submitShop, groupOptions, languageOptions }) => {

    const globalContext = useContext(GlobalContext)
    const serviceContext = useContext(ServiceContext)
    const textContext = useContext(TextContext)
    const navigate = useNavigate()
    const animatedComponents = makeAnimated();
    const [password, setPassword] = useState()
    const [passwordMessage, setPasswordMessage] = useState({ type: 0, mess: '' })
    const [showPassword, setShowPassword] = useState(false)
    const [userOptions, setUserOptions] = useState([])
    const [selectedShopLanguage, setSelectedShopLanguage] = useState()
    const [users, setUsers] = useState([])
    const [exampleMessage, setExampleMessage] = useState('')
    const [mailers, setMailers] = useState([])
    const [mailerOptions, setMailerOptions] = useState([])
    const [selectedShop, setSelectedShop] = useState({ label: globalContext.get.selectedShop.sho_name, value: globalContext.get.selectedShop.ID })
    const [shopOptions, setShopOptions] = useState(globalContext.get.shops.map(sho => { return { label: sho.sho_name, value: sho.ID } }))
    const [submitOpenings, setSubmitOpenings] = useState(false)
    const [editMailerValues, setEditMailerValues] = useImmer({
        ID: undefined,
        mai_username: '',
        mai_password: '',
        mai_host: '',
        mai_secure: undefined,
        mai_port: undefined,
    })
    const [editShopValues, setEditShopValues] = useImmer(defEditShopValues)
    const [editShopCheks, setEditShopCheks] = useImmer(defEditShopChecks)
    const [editMailerCheks, setEditMailerCheks] = useImmer({
        touched: {
            ID: false,
            mai_username: false,
            mai_password: false,
            mai_host: false,
            mai_secure: false,
            mai_port: false,
        },
        check: {
            ID: (v) => { return true },
            mai_username: (v) => { return v.length > 0 && v.length < 150 },
            mai_password: (v) => { return v.length > 0 && v.length < 150 },
            mai_host: (v) => { return v.length > 0 && v.length < 150 },
            mai_secure: (v) => { return true },
            mai_port: (v) => { return v > 0 }
        },
        good: {
            ID: false,
            mai_username: false,
            mai_password: false,
            mai_host: false,
            mai_secure: false,
            mai_port: false,
        },
        bad: {
            ID: false,
            mai_username: false,
            mai_password: false,
            mai_host: false,
            mai_secure: false,
            mai_port: false,
        },
    })
    const [editUserValues, setEditUserValues] = useImmer({
        ID: undefined,
        use_username: '',
        Group: { label: '', value: undefined }
    })
    const [editUserCheks, setEditUserCheks] = useImmer({
        touched: {
            ID: false,
            use_username: false,
            Group: false,
        },
        check: {
            ID: (v) => { return true },
            use_username: (v) => { return v.length > 0 && v.length < 150 },
            Group: (v) => { return true },
        },
        good: {
            ID: false,
            use_username: false,
            Group: false,
        },
        bad: {
            ID: false,
            use_username: false,
            Group: false,
        },
    })

    const changeLanguage = async (e) => {
        setSelectedShopLanguage(e)
        if (!globalContext.get.User.use_lang) {
            textContext.set(draft => { draft.activeLang = e.value })
        }
    }
    const editPassword = async (ID) => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const body = {
            ID: ID,
            use_password: password
        }
        //console.log(body)
        let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })
        let respValue = await resp.json()
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        if (resp.status == 200) {
            setPasswordMessage({ type: 1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['psw_change'], textContext.value) })
            setPassword('')
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['success_password'], textContext.value),
                    ttl: 2000
                })
            })
        } else if (resp.status == 400) {
            setPasswordMessage({ type: -1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['psw_bleh'], textContext.value) })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['skillissue_psw'], textContext.value),
                    ttl: 2000
                })
            })
        } else {
            setPasswordMessage({ type: -1, mess: textContext.get(['sidebar', 'settings', 'shop'], ['error'], textContext.value) })
            serviceContext.set(draft => {
                draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_psw'], textContext.value),
                    ttl: 2000
                })
            })
        }

    }
    const changeMailer = (e) => {
        const l_mailer = JSON.parse(JSON.stringify(mailers.filter(mai => mai.ID == e.value)[0]))
        //console.log('SHOP', shop)
        setEditShopValues(draft => { draft.Mailer_ID = l_mailer.ID })
        setEditMailerValues(l_mailer)
    }
    const changeUser = (e) => {
        // console.log(users.filter(use => use.ID == e.value), e, users)
        const l_user = JSON.parse(JSON.stringify(users.filter(use => use.ID == e.value)[0]))
        //console.log('SHOP', shop)
        setEditUserValues({
            ID: l_user.ID,
            use_username: l_user.use_username,
            Group: globalContext.get.User.Groups.length > 0 ? groupOptions.filter(gr => gr.value == globalContext.get.User.Groups[0].ID)[0] : { label: undefined, value: undefined }
        })
        setEditUserCheks({
            touched: {
                ID: false,
                use_username: false,
                Group: false,
            },
            check: {
                ID: (v) => { return true },
                use_username: (v) => { return v.length > 0 && v.length < 150 },
                Group: (v) => { return true },
            },
            good: {
                ID: false,
                use_username: false,
                Group: false,
            },
            bad: {
                ID: false,
                use_username: false,
                Group: false,
            },
        })
    }
    const checkForm = (values, check, setCheck, show = false) => {
        try {
            let pass = true
            Object.keys(values).forEach(k => {
                if (check.check.hasOwnProperty(k)) {
                    if (check.check[k](values[k])) {

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.good[k] = true })
                            setCheck(draft => { draft.bad[k] = false })
                        }
                    } else {
                        pass = false

                        if (show || check.touched[k]) {
                            setCheck(draft => { draft.bad[k] = true })
                            setCheck(draft => { draft.good[k] = false })
                        }
                    }
                } else {
                    //console.log('CHECK: proprietà non trovata:', k)
                }

            })
            return pass
        } catch (e) {
            console.log('Errore nel check', e)
            return false
        }
    }
    const changeShop = (e) => {
        setSelectedShop(e);
        const shop = JSON.parse(JSON.stringify(globalContext.get.shops.filter(sho => sho.ID == e.value)[0]))
        //console.log('SHOP', shop)
        setEditShopValues(shop)
        setEditMailerValues(shop.Mailer)
        setEditShopCheks({
            touched: {
                ID: false,
                sho_name: false,
                sho_message: false,
                sho_message_time: false,
                sho_sms_sender: false,
                sho_lang: false,
                sho_enable_cr: false,
                sho_default_prefix: false,
            },
            check: {
                ID: (v) => { return true },
                sho_name: (v) => { return v.length > 0 && v.length < 51 },
                sho_message: (v) => { return v.length > 0 && v.length < 150 },
                sho_message_time: (v) => { return v > 0 },
                sho_sms_sender: (v) => { return v.length > 0 && v.length <= 11 },
                Mailer_ID: (v) => { return true }
            },
            good: {
                ID: false,
                sho_name: false,
                sho_message: false,
                sho_message_time: false,
                sho_sms_sender: false,
                sho_enable_cr: false,
                sho_default_prefix: false,
            },
            bad: {
                ID: false,
                sho_name: false,
                sho_message: false,
                sho_message_time: false,
                sho_sms_sender: false,
                sho_enable_cr: false,
                sho_default_prefix: false,
            },
        })
    }
    const editShop = async () => {
        let shopTuched = false
        let mailerTuched = false
        let userTuched = false
        console.log('Start edit')
        Object.keys(editShopCheks.touched).forEach(k => {
            shopTuched = shopTuched || editShopCheks.touched[k]
        })
        Object.keys(editMailerCheks.touched).forEach(k => {
            mailerTuched = mailerTuched || editMailerCheks.touched[k]
        })
        Object.keys(editUserCheks.touched).forEach(k => {
            userTuched = userTuched || editUserCheks.touched[k]
        })

        console.log('Modificati:', shopTuched, mailerTuched, userTuched)
        setSubmitOpenings(true)
        if (shopTuched) {


            const shopBody = {
                ID: editShopValues.ID,
                sho_name: editShopValues.sho_name,
                sho_language: selectedShopLanguage.value,
                sho_message: editShopValues.sho_message,
                sho_message_time: editShopValues.sho_message_time,
                sho_sms_sender: editShopValues.sho_sms_sender,
                // sho_timezone: editShopValues.sho_timezone,
                sho_enable_cr: editShopValues.sho_enable_cr,
                sho_default_prefix: editShopValues.sho_default_prefix,
                sho_default_enable_sms: editShopValues.sho_default_enable_sms,
                sho_default_enable_email: editShopValues.sho_default_enable_email,
                Mailer_ID: editShopValues.Mailer_ID,
            }
            //console.log('Modifica shop')
            if (!checkForm(shopBody, editShopCheks, setEditShopCheks, true)) {
                console.log('check non passato')
                return
            }
            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
            const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/shops`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(shopBody)
            })
            if (resp.status == 200) {
                serviceContext.set(draft => {
                    draft.Alerts.push({
                        ID: Math.random(),
                        message: textContext.get(['calendar', 'notify'], ['sede_success'], textContext.value),
                        ttl: 2000
                    })
                })
            } else {
                serviceContext.set(draft => {
                    draft.Alerts.push({
                        ID: Math.random(),
                        message: textContext.get(['calendar', 'notify'], ['error_modify_sede'], textContext.value),
                        ttl: 2000
                    })
                })
            }
            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })

        }
        if (userTuched) {

            console.log('Modifica user')
            if (!checkForm(editUserValues, editUserCheks, setEditUserCheks, true)) {
                return
            }

            const userBody = {
                ID: editUserValues.ID,
                use_username: editUserValues.use_username,
                Group_ID: editUserValues.Group.value
            }

            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
            const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/users`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userBody)
            })
            if (resp.status == 200) {
                serviceContext.set(draft => {
                    draft.Alerts.push({
                        ID: Math.random(),
                        message: textContext.get(['calendar', 'notify'], ['utent_success'], textContext.value),
                        ttl: 2000
                    })
                })
            } else {
                serviceContext.set(draft => {
                    draft.Alerts.push({
                        ID: Math.random(),
                        message: textContext.get(['calendar', 'notify'], ['utent_error'], textContext.value),
                        ttl: 2000
                    })
                })
            }
            serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading - 1 })
        }


        globalContext.set(draft => { draft.Reloads.user = true })
        resetChecks()
    }
    const downloadPrices = async () => {
        fetch(`${globalContext.get.backendUrl}/papiv1/prices`, {
            method: 'GET',
            credentials: 'include',
        }).then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'prezzario_sms.pdf';
                alink.click();
            })
        })
    }
    const preloadMessage = () => {
        const start = editShopValues.sho_message
        if (start) {
            let mess = start.split("%name%").join('Daniel')
            mess = mess.split("%day%").join('20/12/2023')
            mess = mess.split("%time%").join('12:44')
            mess = mess.split("%surname%").join('Müller')
            setExampleMessage(mess)
        }
    }
    const resetChecks = () => {
        setEditShopCheks(defEditShopChecks)
        setEditUserCheks({
            touched: {
                ID: false,
                use_username: false,
                Group: false,
            },
            check: {
                ID: (v) => { return true },
                use_username: (v) => { return v.length > 0 && v.length < 150 },
                Group: (v) => { return true },
            },
            good: {
                ID: false,
                use_username: false,
                Group: false,
            },
            bad: {
                ID: false,
                use_username: false,
                Group: false,
            },
        })
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }

    useEffect(() => {
        if (submitShop.get) {
            editShop()
            submitShop.set(false)
        }
    }, [submitShop.get])
    useEffect(() => {
        if (globalContext.get) {

            if (globalContext.get.Shop.ID) {
                setShopOptions(globalContext.get.shops.map(sho => { return { label: sho.sho_name, value: sho.ID } }))
                let l_mailers = []
                let ids = []
                globalContext.get.shops.forEach(sho => {
                    if (!ids.includes(sho.Mailer.ID)) {
                        ids.push(sho.Mailer.ID)
                        l_mailers.push(sho.Mailer)
                    }
                })
                setMailers(l_mailers)
                setMailerOptions(l_mailers.map(mai => { return { label: mai.mai_username, value: mai.ID } }))
                changeShop({ label: globalContext.get.selectedShop.sho_name, value: globalContext.get.selectedShop.ID })
                setSelectedShopLanguage({ label: textContext.value.texts[globalContext.get.Shop.sho_language].sidebar.settings.profile.language_name, value: globalContext.get.Shop.sho_language })
            }
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_users = []
                let ids = []
                let l_groups = []
                //console.log('ESECUZIONE loop')
                globalContext.get.shops.forEach(sho => {
                    sho.Users.forEach(use => {
                        if (!ids.includes(use.ID)) {
                            ids.push(use.ID)
                            l_users.push(use)
                        }
                    })
                })
                const userGroup = globalContext.get.User.Groups[0]
                globalContext.get.Agency.Groups.forEach(gro => {
                    if (userGroup.gro_is_admin) {
                        if (!(gro.gro_is_admin && gro.gro_priority > userGroup.gro_priority)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    } else if (userGroup.gro_manage_groups) {
                        if (!(gro.gro_is_admin || gro.gro_priority > userGroup.gro_priority || gro.ID == userGroup.ID)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    }
                })
                setUserOptions(l_users.map(use => { return { label: use.use_username, value: use.ID } }))
                setUsers(l_users)
                setEditUserValues(
                    {
                        ID: globalContext.get.User.ID,
                        use_username: globalContext.get.User.use_username,
                        Group: globalContext.get.User.Groups.length > 0 ? l_groups.filter(gr => gr.value == globalContext.get.User.Groups[0].ID)[0] : { label: undefined, value: undefined }
                    })
            }
        }
    }, [globalContext.get])
    useEffect(() => {
        if (editShopValues.ID) {
            const l_mailer = JSON.parse(JSON.stringify(mailers.filter(mai => mai.ID == editShopValues.Mailer_ID)[0]))
            setEditMailerValues(l_mailer)
        }
        checkForm(editShopValues, editShopCheks, setEditShopCheks)
        preloadMessage()
    }, [editShopValues])
    useEffect(() => {
        checkForm(editMailerValues, editMailerCheks, setEditMailerCheks)
        preloadMessage()
        //console.log('EDIT MAILER', editMailerValues, editShopValues)
    }, [editMailerValues])
    useEffect(() => {
        checkForm(editUserValues, editUserCheks, setEditUserCheks)
        //preloadMessage()
    }, [editUserValues])

    return (
        <>
            <p className='nac-title'>{textContext.get(['sidebar', 'settings', 'shop'], ['sub_title1'], textContext.value)}</p>
            <Row className='mt-4'>
                {getPermission('gro_view_shops') ? (
                    <>
                        <Form.Label><p>{textContext.get(['sidebar', 'settings', 'shop'], ['shop_select'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pttp'
                            components={animatedComponents}
                            options={shopOptions}
                            value={selectedShop}
                            onChange={(e) => changeShop(e)}
                        />
                    </>
                ) :
                    (<></>)}
            </Row>
            <Row className='mt-4'>
                <InputGroup>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['shop_name'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        placeholder='Bellinzona'
                        value={editShopValues.sho_name}
                        onChange={(e) => setEditShopValues(draft => { draft.sho_name = e.target.value })}
                        onFocus={(e) => setEditShopCheks(draft => { draft.touched.sho_name = true })}
                        isValid={editShopCheks.good.sho_name}
                        isInvalid={editShopCheks.bad.sho_name}

                    />
                </InputGroup>
            </Row>
            <Row className='mt-4'>
                <InputGroup hasValidation>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['shop_sms_name'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        placeholder='NACweb'
                        value={editShopValues.sho_sms_sender}
                        onChange={(e) => setEditShopValues(draft => { draft.sho_sms_sender = e.target.value })}
                        onFocus={(e) => setEditShopCheks(draft => { draft.touched.sho_sms_sender = true })}
                        isValid={editShopCheks.good.sho_sms_sender}
                        isInvalid={editShopCheks.bad.sho_sms_sender}

                    />
                </InputGroup>
            </Row>
            <Row className='mt-4'>
                <Form.Label><p>{textContext.get(['sidebar', 'settings', 'shop'], ['language_select'], textContext.value)}</p></Form.Label>
                <Select
                    id='select-pttop'
                    components={animatedComponents}
                    options={languageOptions}
                    value={selectedShopLanguage}
                    onChange={(e) => changeLanguage(e)}
                    onFocus={(e) => setEditShopCheks(draft => { draft.touched.sho_lang = true })}
                />
            </Row>
            <Row className='my-4'>
                <Form.Label><p>{textContext.get(['sidebar', 'settings', 'shop'], ['mailer_select'], textContext.value)}</p></Form.Label>
                <Select
                    id='select-pttpp'
                    components={animatedComponents}
                    options={mailerOptions}
                    value={mailerOptions.filter(opt => opt.value == editShopValues.Mailer_ID)[0]}
                    onChange={(e) => changeMailer(e)}
                />
            </Row>
            <Row className='mt-4'>
                <InputGroup>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['pref'], textContext.value)}</InputGroup.Text>
                    <GoodNumber
                        value={editShopValues.sho_default_prefix}
                        min={1}
                        onChange={(e) => {
                            setEditShopValues(draft => { draft.sho_default_prefix = e });
                            setEditShopCheks(draft => { draft.touched.sho_default_prefix = true })
                        }}
                        isValid={editShopCheks.good.sho_default_prefix}
                        isInvalid={editShopCheks.bad.sho_default_prefix}
                        classes='form-control'
                    />
                </InputGroup>
            </Row>
            <Row className='mt-4 ms-2'>
                <GoodSwitch
                    label={textContext.get(['sidebar', 'settings', 'shop'], ['active_def'], textContext.value)}
                    value={editShopValues.sho_default_enable_sms}
                    inverted={true}
                    onChange={(e) => {
                        setEditShopValues(draft => { draft.sho_default_enable_sms = e });
                        setEditShopCheks(draft => { draft.touched.sho_default_enable_sms = true })
                    }}

                />
            </Row>
            <Row className='mt-4 ms-2'>
                <GoodSwitch
                    label={textContext.get(['sidebar', 'settings', 'shop'], ['active_def2'], textContext.value)}
                    value={editShopValues.sho_default_enable_email}
                    inverted={true}
                    onChange={(e) => {
                        setEditShopValues(draft => { draft.sho_default_enable_email = e });
                        setEditShopCheks(draft => { draft.touched.sho_default_enable_email = true })
                    }}

                />
            </Row>
            <hr />
            <p className='nac-title'>{textContext.get(['sidebar', 'settings', 'shop'], ['sub_title2'], textContext.value)}</p>
            <Row className='mt-4'>
                <InputGroup hasValidation>
                    <p>
                        {textContext.get(['sidebar', 'settings', 'shop'], ['message_instructions_text'], textContext.value)}
                        <li>{textContext.get(['sidebar', 'settings', 'shop'], ['message_instructions_li1'], textContext.value)}</li>
                        <li>{textContext.get(['sidebar', 'settings', 'shop'], ['message_instructions_li2'], textContext.value)}</li>
                        <li>{textContext.get(['sidebar', 'settings', 'shop'], ['message_instructions_li3'], textContext.value)}</li>
                        <li>{textContext.get(['sidebar', 'settings', 'shop'], ['day_appo'], textContext.value)}</li>
                    </p>
                    <InputGroup.Text
                        style={{ borderRadius: '15px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}>{textContext.get(['sidebar', 'settings', 'shop'], ['message_label'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        as="textarea"
                        rows={4}
                        maxLength={149}
                        placeholder={textContext.get(['sidebar', 'settings', 'shop'], ['mex_client'], textContext.value)}
                        value={editShopValues.sho_message}
                        onChange={(e) => setEditShopValues(draft => { draft.sho_message = e.target.value })}
                        onFocus={(e) => setEditShopCheks(draft => { draft.touched.sho_message = true })}
                        isValid={editShopCheks.good.sho_message}
                        isInvalid={editShopCheks.bad.sho_message}
                    />
                </InputGroup>
            </Row>
            <Row className='mt-2'>
                <InputGroup>
                    <InputGroup.Text
                        style={{ borderRadius: '15px', borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}>{textContext.get(['sidebar', 'settings', 'shop'], ['message_example'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        as="textarea"
                        rows={4}
                        value={exampleMessage}
                        disabled={true}
                    />
                </InputGroup>
            </Row>
            <Row className='mt-4'>
                <p>
                    <li>{textContext.get(['sidebar', 'settings', 'shop'], ['message_hours'], textContext.value)}</li>
                </p>
                <InputGroup hasValidation>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['message_hours_unit'], textContext.value)}</InputGroup.Text>
                    <GoodNumber
                        value={editShopValues.sho_message_time}
                        min={1}
                        onChange={(e) => {
                            setEditShopValues(draft => { draft.sho_message_time = e });
                            setEditShopCheks(draft => { draft.touched.sho_message_time = true })
                        }}
                        // onFocus={(e) => setEditShopCheks(draft => { draft.touched.sho_message_time = true })}
                        isValid={editShopCheks.good.sho_message_time}
                        isInvalid={editShopCheks.bad.sho_message_time}
                        classes='form-control'
                    />
                </InputGroup>
            </Row>
            <Row className='my-2 d-flex justify-content-center'>
                <button type='button' className='nac-button' style={{ width: '50%' }} onClick={downloadPrices}>{textContext.get(['sidebar', 'settings', 'profile'], ['download'], textContext.value)}</button>
            </Row>
            {(getPermission('gro_aer_opening', 0) || getPermission('gro_aer_opening', 1) || getPermission('gro_aer_opening', 2)) ? (
                <OpeningSettings
                    selectedShop={selectedShop.value}
                    submitOpeningsSignal={submitOpenings}
                    setSubmitOpeningsSignal={setSubmitOpenings}
                />
            ) : (<></>)}
            {/* {getPermission('gro_aer_user', 1) ? (
                <>
                    <hr />
                    <p className='nac-title'>{textContext.get(['sidebar', 'settings', 'shop'], ['sub_title3'], textContext.value)}</p>
                    <Row className='mt-4'>
                        <Form.Label><p>{textContext.get(['sidebar', 'settings', 'shop'], ['user_select'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pttp'
                            components={animatedComponents}
                            options={userOptions}
                            value={{ label: editUserValues.use_username, value: editUserValues.ID }}
                            onChange={(e) => changeUser(e)}
                        />
                    </Row>
                    <Row className='mt-4'>
                        <Form.Label><p>{textContext.get(['sidebar', 'settings', 'shop'], ['group_select'], textContext.value)}</p></Form.Label>
                        <Select
                            id='select-pttffp'
                            components={animatedComponents}
                            options={groupOptions}
                            value={editUserValues.Group}
                            onChange={(e) => setEditUserValues(draft => { draft.Group = e })}
                            onFocus={(e) => setEditUserCheks(draft => { draft.touched.Group = true })}
                        />
                    </Row>
                    <Row className='mt-4'>
                        <InputGroup>
                            <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['user_username'], textContext.value)}</InputGroup.Text>
                            <FormControl
                                type='text'
                                placeholder='giorgio67'
                                value={editUserValues.use_username}
                                onChange={(e) => setEditUserValues(draft => { draft.use_username = e.target.value })}
                                onFocus={(e) => setEditUserCheks(draft => { draft.touched.use_username = true })}
                                isValid={editUserCheks.good.use_username}
                                isInvalid={editUserCheks.bad.use_username}

                            />
                        </InputGroup>
                    </Row>
                    <Row className='my-4'>
                        <InputGroup>
                            <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'shop'], ['user_password'], textContext.value)}</InputGroup.Text>
                            <FormControl
                                type={showPassword ? 'text' : 'password'}
                                placeholder='password'
                                value={globalContext.get.User.use_password}
                                onChange={(e) => setPassword(e.target.value)}
                                className='password-form'
                            />
                            <button type='button' className='showPassword-container nac-button'>
                                <AiFillEyeInvisible className='nac-text showPassword' size={'15pt'} onClick={() => { setShowPassword(!showPassword) }} />
                            </button>
                            <button type='button' className='nac-button save-password-button' onClick={() => editPassword(editUserValues.ID)}>
                                <RiCheckLine />
                            </button>
                        </InputGroup>
                        <p className='nac-text' style={{ color: passwordMessage.type == 1 ? '#0F0' : '#F00' }}>{passwordMessage.mess}</p>
                    </Row>
                </>
            ) : (<></>)} */}
        </>
    )
}

export default ShopSettings